import React, { useState } from 'react';

import { ModalWrap } from '../../../components/modal-wrap';
import { deleteUserApi } from '../../../api';
import { messageSuccess } from '../../../components/message';
import { jumpToLogin, removeCookieToken } from '../../lib';
import warnImage from '../../../assets/images/warn-yellow.png';
import './style.scss';
import getFormatMessage from '../../../locales/get-format-message';
interface IProps {
  readonly onClose: () => void;
  readonly isShow: boolean;
}

export const DeleteAccount = (props: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [deleteFailed, setDeleteFailed] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(props.isShow);

  const onOk = async () => {
    try {
      setLoading(true);
      const res = await deleteUserApi();
      if (res) {
        messageSuccess(getFormatMessage('delete_success'));
        removeCookieToken();
        setTimeout(() => {
          jumpToLogin();
        }, 1000);
      }
    } catch (err: any) {
      if (err?.apiError?.code === 111302) {
        // 邮件发送失败，但是删除成功的
        messageSuccess(getFormatMessage('delete_success'));
        removeCookieToken();
        setTimeout(() => {
          jumpToLogin();
        }, 1000);
      } else {
        setDeleteFailed(true);
      }
    }
    setLoading(false);
    return true;
  };

  const onClosedModal = () => {
    setShow(false);
    props.onClose();
  };

  const renderDeleteFailedModal = () => {
    if (deleteFailed) {
      return (
        <ModalWrap
          width="480px"
          onOk={onOk}
          onClose={props.onClose}
          title={
            <p className="fail-title">
              <img
                src={warnImage}
                alt="Warning"
                style={{ marginRight: '10px', marginTop: '-2px' }}
              />
              <span className="delete-modal-text">
                {getFormatMessage('delete_failed')}
              </span>
            </p>
          }
          className="delete-modal delete-dialog"
          cancelText="Cancel"
        >
          <div className="delete-text remove-text">
            {getFormatMessage('you_will_need_to')} <br />{' '}
            {getFormatMessage('add_new_admin_or_del_all_titles')}
          </div>
        </ModalWrap>
      );
    }
    return null;
  };

  const renderDeleteModal = () => {
    if (show) {
      return (
        <ModalWrap
          width="500px"
          onOk={onOk}
          onClose={onClosedModal}
          title={
            <p className="fail-title">
              <img
                src={warnImage}
                alt="Warning"
                style={{ marginRight: '10px', marginTop: '-2px' }}
              />
              <span>{getFormatMessage('delete_account')}</span>
            </p>
          }
          className="delete-modal delete-dialog"
          okButtonProps={{
            danger: true,
          }}
          loading={loading}
          cancelText={getFormatMessage('cancel')}
          oKText={getFormatMessage('delete_account')}
        >
          <div className="delete-text">
            <div className="remove-text">
              {getFormatMessage('only_user_or_owner_desc')}
              <br /> {getFormatMessage('add_admin_or_del_all')}
              <br />
              {getFormatMessage('process_irreversible_desc')}
              <br />
              {getFormatMessage('sure_delete_account')}
            </div>
          </div>
        </ModalWrap>
      );
    }
    return null;
  };

  return (
    <>
      {renderDeleteModal()}
      {renderDeleteFailedModal()}
    </>
  );
};
